<template>
  <!-- start preloader -->
  <!-- <div class="preloader" id="preloader"></div> -->
  <!-- end preloader -->

  <!-- Scroll To Top Start-->
  <router-link to="javascript:void(0)" class="scrollToTop"
    ><i class="fas fa-angle-double-up"
  /></router-link>
  <!-- Scroll To Top End -->

  <!-- ===========Banner Section start Here========== -->
  <section class="banner">
    <div class="container">
      <div class="row g-0">
        <div class="col-xl-6 col-lg-7 col-12">
          <div class="banner__content">
            <h3>the best website</h3>
            <h1>Online Casino</h1>
            <h2>Win Money Unlimited</h2>
            <p>
              PLAY CASINO AND EARN CRYPTO IN ONLINE. THE ULTIMATE ONLINE CASINO
              PLATFORM.
            </p>
            <div
              class="default-button tw-cursor-pointer"
              @click="openPopup('register')">
              <span>join us today <i class="icofont-play-alt-1"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ===========Banner Section Ends Here========== -->

  <!-- ===========counter Section Ends Here========== -->
  <section class="counter">
    <div class="container">
      <div class="counter__area">
        <div class="row align-items-center">
          <div class="col-lg-5 counter__left">
            <div>
              <h2>TODAY YOU CAN WIN UPTO</h2>
            </div>
          </div>
          <div class="col-lg-7 col-12 text-center counter__right">
            <!-- <ul class="d-flex flex-row">
              <li class="counter-text border-count counter-after">
                <h3 class="m-0">$</h3>
              </li>
              <li class="counter-text border-count">
                <h3
                  class="counter__number odometer mb-0"
                  :data-odometer="2251259">
                  0
                </h3>
              </li>
            </ul> -->
            <ul>
              <li class="counter-text border-count">
                <h3 class="counter-after">$</h3>
              </li>
              <li class="counter-text border-count">
                <h3 class="counter counter-after">1</h3>
              </li>
              <li class="counter-text border-count">
                <h3 class="counter counter-after">2</h3>
              </li>
              <li class="counter-text border-count">
                <h3 class="counter counter-after">3</h3>
              </li>
              <li class="counter-text border-count">
                <h3 class="counter counter-after">4</h3>
              </li>
              <li class="counter-text border-count">
                <h3 class="counter counter-after">5</h3>
              </li>
              <li class="counter-text border-count">
                <h3 class="counter counter-after">6</h3>
              </li>
              <li class="counter-text border-count">
                <h3 class="counter counter-after">7</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ===========counter Section Ends Here========== -->

  <!-- ===========Collection Section Start Here========== -->
  <section class="collection-section padding-top padding-bottom">
    <div class="container">
      <div class="section-header">
        <h2>welcome to casino</h2>
      </div>
      <div class="section-wrapper game">
        <div class="row g-4 justify-content-center">
          <div class="col-lg-4 col-sm-6 col-12">
            <div class="game__item item-layer">
              <div class="game__inner text-center">
                <div class="game__thumb">
                  <img src="../assets/images/game/01.png" alt="game-img" />
                </div>
                <div class="game__content">
                  <h4>Advice And Guide</h4>
                  <p>
                    Comprehensive Advice and Step-by-Step Guidance for Every
                    Journey
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 col-12">
            <div class="game__item item-layer">
              <div class="game__inner text-center">
                <div class="game__thumb">
                  <img src="../assets/images/game/02.png" alt="game-img" />
                </div>
                <div class="game__content">
                  <h4>Great Solutions</h4>
                  <p>
                    Powerful Solutions Tailored to Overcome Every Challenge and
                    Achieve Success
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 col-12">
            <div class="game__item item-layer">
              <div class="game__inner text-center">
                <div class="game__thumb">
                  <img src="../assets/images/game/03.png" alt="game-img" />
                </div>
                <div class="game__content">
                  <h4>Support in Person</h4>
                  <p>
                    Dedicated In-Person Support to Guide You Every Step of the
                    Way
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ===========Collection Section Ends Here========== -->

  <!-- ===========Game Section Ends Here========== -->
  <div
    class="game-section padding-top padding-bottom overflow-hidden gaming-section">
    <div class="container">
      <div class="section-header">
        <h2>RELATED OTHER GAMES</h2>
      </div>
      <ul class="game__filter">
        <li data-filter="*" class="is-checked">
          <div class="category">All</div>
        </li>
        <li data-filter=".cat-1"><span class="category">Pragmatic</span></li>
        <li data-filter=".cat-2"><span class="category">Evolution</span></li>
        <li data-filter=".cat-3"><span class="category">Spribe</span></li>
      </ul>
      <div class="row g-4 grid">
        <div class="col-lg-4 col-12 cat-1">
          <div class="game__item item-layer">
            <div class="game__inner text-center p-0">
              <div class="game__thumb mb-0">
                <img
                  src="../assets/images/game1.png"
                  alt="game-img"
                  class="rounded-3 w-100" />
              </div>
              <div class="game__overlay">
                <div class="game__overlay-left">
                  <h4>free poker games</h4>
                  <p>Catagory: Roulette</p>
                </div>
                <div class="game__overlay-right">
                  <router-link to="/casino/all" class="default-button"
                    ><span>play now <i class="icofont-circled-right"></i></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12 cat-2">
          <div class="game__item item-layer">
            <div class="game__inner text-center p-0">
              <div class="game__thumb mb-0">
                <img
                  src="../assets/images/game2.png"
                  alt="game-img"
                  class="rounded-3 w-100" />
              </div>
              <div class="game__overlay">
                <div class="game__overlay-left">
                  <h4>free poker games</h4>
                  <p>Catagory: Roulette</p>
                </div>
                <div class="game__overlay-right">
                  <router-link to="/casino/all" class="default-button"
                    ><span>play now <i class="icofont-circled-right"></i></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12 cat-3">
          <div class="game__item item-layer">
            <div class="game__inner text-center p-0">
              <div class="game__thumb mb-0">
                <img
                  src="../assets/images/game3.png"
                  alt="game-img"
                  class="rounded-3 w-100" />
              </div>
              <div class="game__overlay">
                <div class="game__overlay-left">
                  <h4>free poker games</h4>
                  <p>Catagory: Roulette</p>
                </div>
                <div class="game__overlay-right">
                  <router-link to="/casino/all" class="default-button"
                    ><span>play now <i class="icofont-circled-right"></i></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12 cat-4">
          <div class="game__item item-layer">
            <div class="game__inner text-center p-0">
              <div class="game__thumb mb-0">
                <img
                  src="../assets/images/game4.png"
                  alt="game-img"
                  class="rounded-3 w-100" />
              </div>
              <div class="game__overlay">
                <div class="game__overlay-left">
                  <h4>free poker games</h4>
                  <p>Catagory: Roulette</p>
                </div>
                <div class="game__overlay-right">
                  <router-link to="/casino/all" class="default-button"
                    ><span>play now <i class="icofont-circled-right"></i></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12 cat-1">
          <div class="game__item item-layer">
            <div class="game__inner text-center p-0">
              <div class="game__thumb mb-0">
                <img
                  src="../assets/images/game5.png"
                  alt="game-img"
                  class="rounded-3 w-100" />
              </div>
              <div class="game__overlay">
                <div class="game__overlay-left">
                  <h4>free poker games</h4>
                  <p>Catagory: Roulette</p>
                </div>
                <div class="game__overlay-right">
                  <router-link to="/casino/all" class="default-button"
                    ><span>play now <i class="icofont-circled-right"></i></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12 cat-1">
          <div class="game__item item-layer">
            <div class="game__inner text-center p-0">
              <div class="game__thumb mb-0">
                <img
                  src="../assets/images/game6.png"
                  alt="game-img"
                  class="rounded-3 w-100" />
              </div>
              <div class="game__overlay">
                <div class="game__overlay-left">
                  <h4>free poker games</h4>
                  <p>Catagory: Roulette</p>
                </div>
                <div class="game__overlay-right">
                  <router-link to="/casino/all" class="default-button"
                    ><span>play now <i class="icofont-circled-right"></i></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="button-wrapper text-center mt-5">
        <a href="game-list2.html" class="default-button"
          ><span>Browse All Matches <i class="icofont-circled-right"></i></span>
        </a>
      </div> -->
    </div>
  </div>
  <!-- ===========Game Section Ends Here========== -->

  <div class="game game-style3 overflow-hidden game-picutre">
    <div class="container">
      <div class="section-wrapper">
        <div class="row justify-content-center g-4 align-items-center">
          <div class="col-lg-6 col-12">
            <div class="game__thumb">
              <img src="../assets/images/free_bonus.png" alt="game-thumb" />
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="game__content">
              <div class="section-header text-start">
                <h2>Welcome Bonus</h2>
                <p class="welcome-bonus">
                  Up to €1,750 + 150 FS + 1 Bonus Crab in 3 bonuses
                </p>
                <div
                  class="default-button tw-cursor-pointer"
                  @click="openPopup('register')">
                  <span>sign up <i class="icofont-circled-right"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ===========Game Section Ends Here========== -->

  <!-- ===========Testimonial Section Start Here========== -->
  <div class="bg-testimonial">
    <div class="testimonial padding-top padding-bottom">
      <div class="container">
        <div class="section-header">
          <h2>our gamers reviews</h2>
          <p>
            At Modeltheme, we show only the best websites and portfolios built
            completely with passion simplicity and creativity !
          </p>
        </div>
        <div class="section-wrapper">
          <div class="row g-4">
            <div class="col-lg-6 col-12">
              <div class="testimonial-slider overflow-hidden">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="testimonial-item">
                      <div class="testimonial-inner">
                        <div class="testimonial-head">
                          <div class="testi-top">
                            <div class="testimonial-thumb">
                              <img
                                src="../assets/images/user.png"
                                alt="testimonial" />
                            </div>
                            <div class="name-des">
                              <h5>Fahad Foiz</h5>
                            </div>
                          </div>
                          <div class="testimonial-footer">
                            <ul>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                            </ul>
                            <h5>5.28</h5>
                          </div>
                        </div>
                        <div class="testimonial-body">
                          <p>
                            "Play casino and earn crypto in online. The ultimate
                            online casino platform. Play casino and earn crypto
                            in online.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="testimonial-item">
                      <div class="testimonial-inner">
                        <div class="testimonial-head">
                          <div class="testi-top">
                            <div class="testimonial-thumb">
                              <img
                                src="../assets/images/user.png"
                                alt="testimonial" />
                            </div>
                            <div class="name-des">
                              <h5>Stan Lazi</h5>
                            </div>
                          </div>
                          <div class="testimonial-footer">
                            <ul>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                            </ul>
                            <h5>5.28</h5>
                          </div>
                        </div>
                        <div class="testimonial-body">
                          <p>
                            "Join the best online casino and win big! Experience
                            the thrill of online gambling with our secure
                            platform."
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="testimonial-slider overflow-hidden">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="testimonial-item">
                      <div class="testimonial-inner">
                        <div class="testimonial-head">
                          <div class="testi-top">
                            <div class="testimonial-thumb">
                              <img
                                src="../assets/images/user.png"
                                alt="testimonial" />
                            </div>
                            <div class="name-des">
                              <h5>Uahad Foiza</h5>
                            </div>
                          </div>
                          <div class="testimonial-footer">
                            <ul>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                            </ul>
                            <h5>5.28</h5>
                          </div>
                        </div>
                        <div class="testimonial-body">
                          <p>
                            "Enjoy a wide range of casino games and earn
                            rewards. Experience the thrill of online gambling
                            with our secure platform."
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="testimonial-item">
                      <div class="testimonial-inner">
                        <div class="testimonial-head">
                          <div class="testi-top">
                            <div class="testimonial-thumb">
                              <img
                                src="../assets/images/user.png"
                                alt="testimonial" />
                            </div>
                            <div class="name-des">
                              <h5>John Doe</h5>
                            </div>
                          </div>
                          <div class="testimonial-footer">
                            <ul>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                              <li><i class="icofont-ui-rate-blank"></i></li>
                            </ul>
                            <h5>5.28</h5>
                          </div>
                        </div>
                        <div class="testimonial-body">
                          <p>
                            "Experience the thrill of online gambling with our
                            secure platform. Experience the thrill of online
                            gambling with our secure platform."
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ===========Testimonial Section Ends Here========== -->

  <!-- ================ footer Section start Here =============== -->

  <!-- ================ footer Section end Here =============== -->

  <!-- Popular Game start -->
  <HomePopularGames :games="allGames" />
  <!-- Popular Game end -->
</template>

<script>
import Const from '@/const'
// import HomeProviders from "@/components/HomeProviders.vue";
// import HomeGameProviders from "@/components/HomeGameProviders.vue";
import { allGames } from '@/sampleData'
import { useAuthStore } from '../stores/authStore'
import { usePopupStore } from '../stores/popup'
// import { Carousel, Slide } from "vue3-carousel";
import { reactive, ref } from 'vue'

import Odometer from 'odometer'
import 'odometer/themes/odometer-theme-default.css'

export default {
  name: 'HomePage',
  components: {
    // HomeProviders,
    // Carousel,
    // Slide,
    // HomeGameProviders,
    // ReviewsComponent,
  },
  setup() {
    const config = reactive({
      itemsToShow: 1,
      autoplay: 6000,
      gap: 0,
      wrapAround: true,
      transition: 1000,
    })

    const carousel = ref(null)

    const prevSlide = () => {
      if (carousel.value) {
        carousel.value.prev()
      }
    }

    const nextSlide = () => {
      if (carousel.value) {
        carousel.value.next()
      }
    }

    return {
      config,
      carousel,
      prevSlide,
      nextSlide,
    }
  },
  data() {
    return {
      serverData: null, // Holds data fetched from the server
      allGames: allGames,
      welcomeBonusShowed: false,
      odometerValue: 2251259,
    }
  },
  computed: {
    // Access the isAuthenticated property from Pinia store
    isAuthenticated() {
      const authStore = useAuthStore()
      return authStore.isAuthenticated
    },
  },
  unmounted() {
    window.removeEventListener('scroll', this.actionScroll)
  },
  created() {
    window.addEventListener('scroll', this.actionScroll)
  },
  mounted() {
    //this.fetchHomeCasino(); // Fetch data when the component is mounted
    const odometerElement = document.querySelector('.odometer')
    if (odometerElement) {
      const odometerInstance = new Odometer({
        el: odometerElement,
        value: this.odometerValue,
      })
    }
  },
  methods: {
    openPopup(popup) {
      const popupStore = usePopupStore()
      popupStore.showPopup(popup)
    },
    actionScroll() {
      const scroll = window.scrollY
      if (scroll == 0 && this.welcomeBonusShowed == false) {
        // this.openPopup('welcome-bonus');
        // this.welcomeBonusShowed = true;
      }
    },
    async fetchHomeCasino() {
      const url = Const.URL

      const headers = {
        Accept: 'application/json, text/plain, */*',
        'Accept-Language': 'en-US,en;q=0.9,uk-UA;q=0.8,uk;q=0.7,pl;q=0.6',
        'Cache-Control': 'no-cache',
        Connection: 'keep-alive',
        'Content-Type': 'application/json',
        Cookie:
          'remember_web_59ba36addc2b2f9401580f014c7f58ea4e30989d=eyJpdiI6ImpnUDhDZWNhZmlwUnhJczdCdjY3cEE9PSIsInZhbHVlIjoiTXNqeWFqVm1UeXJjSEFMMm5wS3liajlWL2Z6QWQvZklBQldlNytpbGJWUmorSDhZWU1ZL21qRURCVUR3UW8yVTN5V0lFczB4cS90MVpYcDF6N2VRZjh0N1c2aitLb1FGSW1Xd3FpYzFTSkVqTUtuSVkvL04xMDR4NW9MRUtFM1d2SXc3T0lRMldLSndRQjVMSTlkcGxoTEpQM1NvUEFmRDZkcFV2RXE4d2Q5a3N0VUpMM09zOTY2dHIxZzVxWnM4Q3M5clFmTU1YLzZUM3pOU2xzY0plS1VMODNTN3Q3Ym9RbC90MnVlNHRzRT0iLCJtYWMiOiI4MjA5OGQxOWUzZGZlZGJkMzY3MGE4MmI4OTA2YzU5ZmQyZDllMzc1ZTgxYzUxMzA5NzgyOTgzNzcyM2M0ZGIzIn0%3D; XSRF-TOKEN=eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0%3D; laravel_session=eyJpdiI6InN0UHFVTExkLzdwaU01cTNLVENldkE9PSIsInZhbHVlIjoiWDlsRk5nUnVWdTMzU1lKclllbG1KYXkxdkpHbEU5cXNPcGlBVks3ZGpBdmpRbFBiYVRhRWJRVC9RMjZ0N2xndTdlZndaZnRDdHNsOVBHWmVOUFgyallMWkNNQ0ZNNThHdldaTjliNUhhWWFxdUNWU0ZxVG84V3g1OWkrTWZ5c3IiLCJtYWMiOiIyYzk3ZWFiOWFiMzk4YjBiNmRkZWM4MGEzMmFhMzc5NTBjMjhjYTA3ZTE4YzAxMWE4YzRhYjRjNzVlMjY5YjJhIn0%3D',
        DNT: '1',
        Origin: 'https://azurecoinz.com',
        Pragma: 'no-cache',
        Referer: 'https://azurecoinz.com/home',
        'Sec-Fetch-Dest': 'empty',
        'Sec-Fetch-Mode': 'cors',
        'Sec-Fetch-Site': 'same-origin',
        'User-Agent':
          'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36',
        'X-XSRF-TOKEN':
          'eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0=',
        'sec-ch-ua':
          '"Google Chrome";v="131", "Chromium";v="131", "Not_A Brand";v="24"',
        'sec-ch-ua-mobile': '?0',
        'sec-ch-ua-platform': '"macOS"',
        timeout: '10000',
      }

      const body = {}

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        this.serverData = data // Update the component's state with the fetched data
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
  },
}
</script>

<style scoped>
.home {
  text-align: center;
  padding: 20px;
}
.home-wrapper .carousel__slide {
  justify-content: space-between;
}
.home-wrapper .custom-main-container {
  max-width: 1320px;
}

.counter-text h3 {
  font-size: 50px;
  color: $color_6;
  line-height: 24px;
  font-weight: 400;
  font-family: $font-family_3;
  text-transform: uppercase;
  cursor: auto;
  width: 50px;
  height: 68px;
  margin: 0 5px;
  margin-top: 4px;
  padding-top: 20px;
  background-image: linear-gradient(
    to bottom,
    #ffffff,
    #f1d5fa,
    #faa2dc,
    #ff66a2,
    #ff0052
  );
}

@media (max-width: 1400px) {
  .home-wrapper .custom-main-container {
    max-width: 1100px;
  }
}

@media (max-width: 1200px) {
  .home-wrapper .custom-main-container {
    max-width: calc(100% - 120px);
  }
  .banner-image-wrap {
    width: 50%;
  }
  .banner-image-wrap img {
    height: 100%;
    width: 100%;
  }
  .home-wrapper .main-content .section-text .title {
    font-size: 44px;
    line-height: normal;
  }
}

@media (max-width: 768px) {
  .home-wrapper .custom-main-container {
    max-width: 100%;
  }
  .banner-image-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0.5;
  }
  .home-wrapper .banner-image-wrap img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .home-wrapper .main-content {
    padding: 48px 40px;
  }
  .banner-section .overlay .banner-content {
    padding: 70px 0 0px;
  }
  .inner-content-element {
    margin: 0 auto;
  }
}

@media (max-width: 576px) {
  .home-wrapper .main-content {
    padding: 0 20px;
  }
  .home-wrapper .main-content .section-text .title {
    font-size: 40px;
    text-align: center;
  }
  .home-wrapper .main-content .section-text .xlr {
    text-align: center;
  }
  .banner-section.index .overlay .banner-content {
    padding: 87px 0 0px;
  }
  .inner-content-element {
    padding-bottom: 30px;
    padding-top: 100px;
  }
  .btn-element {
    text-align: center;
  }
  .counter-text h3 {
    font-size: 16px;
    color: $color_6;
    line-height: 24px;
    font-weight: 400;
    font-family: $font-family_3;
    text-transform: uppercase;
    cursor: auto;
    width: 30px;
    height: 40px;
    margin: 0 2px;
    margin-top: 4px;
    padding-top: 7px;
    background-image: linear-gradient(
      to bottom,
      #ffffff,
      #f1d5fa,
      #faa2dc,
      #ff66a2,
      #ff0052
    );
  }
}

.banner-image-wrap img {
  overflow: clip;
  max-width: none;
  overflow-clip-margin: content-box;
  overflow: clip;
  max-height: 500px;
}

.banner-item .main-content {
  text-align: left;
}
</style>
